import { render } from "./FolderApplicationsModal.vue?vue&type=template&id=c81c0484&scoped=true&ts=true"
import script from "./FolderApplicationsModal.vue?vue&type=script&lang=ts"
export * from "./FolderApplicationsModal.vue?vue&type=script&lang=ts"

import "./FolderApplicationsModal.vue?vue&type=style&index=0&id=c81c0484&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81c0484"]])

export default __exports__